import React from 'react';

const ADMIN_NAV_ITEMS = [
  { id: 'dashboard',    icon: '📊', label: 'Dashboard' },
  { id: 'inventory',    icon: '🧃', label: 'Inventory' },
  { id: 'transactions', icon: '🧾', label: 'Transactions' },
  { id: 'analytics',   icon: '📈', label: 'Analytics' },
  { id: 'peakhours',   icon: '🕐', label: 'Peak Hours' },
  { id: 'promo',       icon: '🎉', label: 'Promo Control' },
  { id: 'managers',    icon: '👥', label: 'Manage Managers' },
];

// Managers only ever see the Dashboard tab, scoped to their assigned kiosks.
const MANAGER_NAV_ITEMS = [
  { id: 'dashboard', icon: '📊', label: 'Dashboard' },
];

export default function Sidebar({ activeTab, onTabChange, onLogout, role, userName, mobileOpen, onCloseMobile }) {
  const NAV_ITEMS = role === 'manager' ? MANAGER_NAV_ITEMS : ADMIN_NAV_ITEMS;
  const isManager = role === 'manager';
  const displayName = isManager ? (userName || 'Manager') : 'Admin';
  const roleLabel = isManager ? 'Kiosk Manager' : 'Fleet Manager';
  const avatarLetter = displayName.trim().charAt(0).toUpperCase() || 'A';
  return (
    <>
      {mobileOpen && <div className="sidebar-backdrop" onClick={onCloseMobile} />}
      <aside className={`sidebar ${mobileOpen ? 'sidebar--mobile-open' : ''}`}>
        <div className="sidebar-top">
          {/* Brand */}
          <div className="sidebar-brand">
            <img className="sidebar-brand-icon" src="/logo192.png" alt="Chill Ras" />
            <div>
              <div className="sidebar-brand-name">Chill Ras</div>
              <div className="sidebar-brand-tag">Fleet Command</div>
            </div>
            <button className="sidebar-mobile-close" onClick={onCloseMobile} aria-label="Close menu">✕</button>
          </div>

          {/* User */}
          <div className="sidebar-user">
            <div className="sidebar-avatar">{avatarLetter}</div>
            <div>
              <div className="sidebar-user-name">{displayName}</div>
              <div className="sidebar-user-role">{roleLabel}</div>
            </div>
          </div>

          {/* Navigation */}
          <nav className="sidebar-nav">
            <div className="sidebar-nav-label">Navigation</div>
            {NAV_ITEMS.map((item) => (
              <button
                key={item.id}
                id={`nav-${item.id}`}
                className={`sidebar-nav-item ${activeTab === item.id ? 'sidebar-nav-item--active' : ''}`}
                onClick={() => { onTabChange(item.id); onCloseMobile?.(); }}
              >
                <span className="sidebar-nav-icon">{item.icon}</span>
                {item.label}
              </button>
            ))}
          </nav>
        </div>

        <div className="sidebar-bottom">
          <div className="sidebar-status">
            <span className="sidebar-status-dot" />
            <span>All Systems Online</span>
          </div>
          <button id="logout-button" className="sidebar-logout" onClick={onLogout}>
            <span>🔒</span> Secure Logout
          </button>
        </div>
      </aside>
    </>
  );
}
